var render = function render(){var _vm=this,_c=_vm._self._c;return _c('what-is-this-link',[_c('div',{staticClass:"card-number-help"})])
}
var staticRenderFns = []

export { render, staticRenderFns }